export default "__VITE_ASSET__H5nWZ3BA__"